import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import BusinessTimeLightSVG from '@jobcase/react_pattern_library/components/SVGIcon/icons/BusinessTimeLightSVG';
import LinkRebrand, { PREV_LINK_STYLES } from '@jobcase/react_pattern_library/components/Link/LinkRebrand';
import SVGIcon from '@jobcase/react_pattern_library/components/SVGIcon';
import styles from '@jobcase/react_pattern_library/styles/rebrand';

import {
  routeToWFSOptimization,
  routeToRetailOptimization,
  routeToPillpackOptimization,
} from '../../../redux/nodes/router/actions';

import { TRANSITION_DELAY } from '../../../utils/constants/employerNavigation';
import { useAppContext } from '../../../utils/hooks';

const StyledLink = styled(LinkRebrand).attrs({ linkStyle: PREV_LINK_STYLES.NO_UNDERLINE })`
  align-items: center;
  border: none;
  display: flex;
  font-weight: ${({ bold }) => (bold ? '500' : '400')};
  max-height: 74px;
  min-height: 60px;
  min-width: 240px;
  padding: 0 ${styles.spacing.small + 2}px 0 ${styles.spacing.tiny}px;
  position: relative;
  text-decoration: none;
  transition: height ${TRANSITION_DELAY}s;

  ${({ isSelected }) => isSelected && css`
    background-color: ${styles.color.commentBoxGrayColor};

    &:before {
      background-color: ${styles.color.primaryColor};
    }
  `}

  &:before {
    bottom: 0;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 4px;
  }

  &:hover {
    background-color: ${styles.color.commentBoxGrayColor};
  }

  @media(min-width: ${styles.breakpoint.md}) {
    padding: ${styles.spacing.tiny + 2}px ${styles.spacing.tiny}px;
  }
`;

const NavIcon = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-right: ${styles.spacing.tiny}px;

  svg {
    margin: 0;
    min-width: 24px;
    stroke-width: 16px;

    path {
      fill: ${styles.color.jobcaseBlackColor};
    }
  }
`;

const NavLink = styled.div`
  color: ${styles.color.jobcaseBlackColor};
  font-weight: 600;
  line-height: ${styles.font.lineHeight.body2};
`;

const AmazonSpecificNavItems = ({ currentEmployerId, isLabelHidden }) => {
  const { isMobile } = useAppContext();

  const onClick = () => {
    if (currentEmployerId === '1897bc5f-f610-40b5-a8cc-b58baffefdcc') {
      routeToWFSOptimization();
    } else if (currentEmployerId === '30733d0d-64db-46ef-89fe-14b9b350eb5d') {
      routeToRetailOptimization();
    } else if (currentEmployerId === 'e77c99e5-b6ba-4a56-b30d-ae38ce0530bb') {
      routeToPillpackOptimization();
    }
  };

  return (
    <StyledLink onClick={onClick}>
      <NavIcon>
        <SVGIcon
          svgChild={BusinessTimeLightSVG}
          color={styles.color.jobcaseBlackColor}
        />
      </NavIcon>
      {(!isMobile && isLabelHidden) && (
        <NavLink>
          Job Campaigns &amp; Optimization Campaigns
        </NavLink>
      )}
      {isMobile && (
        <NavLink>
          Job Campaigns &amp; Optimization Campaigns
        </NavLink>
      )}
    </StyledLink>
  );
};

AmazonSpecificNavItems.propTypes = {
  currentEmployerId: PropTypes.string,
  isLabelHidden: PropTypes.bool,
};

AmazonSpecificNavItems.defaultProps = {
  currentEmployerId: null,
  isLabelHidden: false,
};

export default AmazonSpecificNavItems;
